<template>
  <div :class="themeFormat.name" id="app" class="footer">
    <!-- <transition name="van-slide-right" mode="out"> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
    <!-- </transition> -->
    <van-tabbar
      route
      v-if="showTabbar&&account"
      :active-color="themeColor"
      @change="onChange"
      >

    <!--  <van-tabbar-item v-if="!ifEnterpriseGoods"
        replace
        to="/"
        color="#EF4056"
      >
        <van-icon
          slot="icon"
          slot-scope="props"
          class-prefix="st-icon"
          :name="props.active ? themeFormat.tabbarIcons.homeOn : themeFormat.tabbarIcons.home"
        />
        <template v-if="store === 'cloudCooperation'">
          我的相册
        </template>
       <span v-else>
          首页
        </span>
      </van-tabbar-item> -->

      <template v-if="store !== 'cloudCooperation'">
        <van-tabbar-item
          replace
          to="/category"
          v-if="!industryCode"
        >
          <van-icon
            slot="icon"
            slot-scope="props"
            class-prefix="st-icon"
            :name="props.active ? '../static/imgs/home1.png' : '../static/imgs/home2.png'"
          />
          <span>
            商城
          </span>
        </van-tabbar-item>
        <van-tabbar-item
          replace
          to="/templateCategory"
          v-if="industryCode"
        >
          <van-icon
            slot="icon"
            slot-scope="props"
            class-prefix="st-icon"
            :name="props.active ? themeFormat.tabbarIcons.categoryOn : themeFormat.tabbarIcons.category"
          />
          <span>
            模板
          </span>
        </van-tabbar-item>
        <van-tabbar-item
          replace
          to="/enterpriseGoods"
          v-if="ifEnterpriseGoods"
        >
          <van-icon
            slot="icon"
            class-prefix="st-icon"
            name="openwallet"
          />
          <span>
            企业商品
          </span>
        </van-tabbar-item>
       <!-- <van-tabbar-item v-if="tenantType!=='2' && !ifEnterpriseGoods"
          :to="vipState?'/lingquyouhuiquan':'/88vip'"
        >
          <van-icon
            slot="icon"
            class-prefix="st-icon"
            name="aftersale"
          />
          88VIP
        </van-tabbar-item> -->
          <!-- <van-icon
            class="service"
            slot="icon"
            class-prefix="st-icon"
            name="servicel"
          />
          <span class="servicetxt">
            定制顾问
          </span> -->
        <van-tabbar-item
          replace
          to="/cart"
          v-if="!$store.state.app.isDanBo&&!$store.state.app.isZhongfu"
        >
          <van-icon
            slot="icon"
            slot-scope="props"
            class-prefix="st-icon"
            :name="props.active ? '../static/imgs/gouwuche1.png' : '../static/imgs/gouwuche.png'"
          />
          <span>
            购物车
          </span>
        </van-tabbar-item>
      </template>

      <van-tabbar-item
        replace
        to="/user"
      >
        <van-icon
          slot="icon"
          slot-scope="props"
          class-prefix="st-icon"
          :name="props.active ? '../static/imgs/wode.png' : '../static/imgs/wode2.png'"
        />
        <span>
          我的
        </span>
      </van-tabbar-item>
    </van-tabbar>
    <agreementPopup />
  </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import GlobalEvent from '@/Event/GlobalEvent.js'
    import {Tabbar, TabbarItem, Icon, Toast} from 'vant';
    import {doJsonPost,doFormPost} from '@/utils/request';
    import {setCustomerService,setIfEnterprise,setTenantType,getTenantType} from '@/utils/auth';
    import agreementPopup from '@/components/agreementPopup'

    export default {
        name: 'App',
        components: {
            [Tabbar.name]: Tabbar,
            [TabbarItem.name]: TabbarItem,
            [Icon.name]: Icon,
            agreementPopup
        },
        data() {
            return {
              tenantType:'',
              vipState:false,
              account:false,
            }
        },
        computed: {
            ...mapGetters([
                'theme',
                'storeType',
                'ifEnterpriseGoods',
                'industryCode'
            ]),
            themeColor() {
                return this.theme.colors[1]
            },
            themeFormat() {
                return this.theme.format
            },
            showTabbar() {
                return this.$route.meta.showTabbar
            },
            store() {
                return this.storeType
            }
        },
        mounted() {
         var account = localStorage.getItem("account");
         if(account){
           this.account = true;
         }
           this.getUserInfo();
           this.getIfEnterpriseGoods();
            this.getCustomerService();
            this.initGlobalData();
            this.tenantType=getTenantType();
            this.hualaishiUserCheck();
            this.getStyle();
             GlobalEvent.create('showNavbar').listen('Navbar', this.changeshowBar);
        },
        methods: {
          changeshowBar(account){
            this.account = account;
          },
          //添加华莱士和保险公司人员权限校验
          hualaishiUserCheck() {
            var that = this;
              doJsonPost('/wechatLogin/checkHuaLaiShiUser', null, rs => {
                  console.info(rs)
                  if (rs.result === 'success') {
                    if(rs.userData&&rs.userData.usrUser){
                      if(rs.userData.usrUser.phone==""||rs.userData.usrUser.phone==null){
                        console.info("不处理")
                      }else{
                        that.$store.dispatch('setOpenId', rs.userData.usrUser.wxOpenid);
                        var hua = rs.userData.hualaishiUser;
                        localStorage.setItem("maxNum", hua.maxNum)
                        localStorage.setItem("areadyNum", hua.areadyNum)
                        localStorage.setItem("phone", hua.phone)
                        localStorage.setItem("userName", hua.name)
                        localStorage.setItem("hualaishiCode", hua.shopCode)
                        that.$store.dispatch('setUserName', hua.name);
                        that.$store.dispatch('setChildShopName', hua.childShopName);
                        that.$store.dispatch('setChildShopCode', hua.childShopCode);
                        GlobalEvent.create('screenShot').trigger('toDataURLComplete',hua.childShopName);
                        // that.$store.dispatch('setUserName', hua.name);
                        // that.$store.dispatch('setPhone', hua.phone);
                        // that.$store.dispatch('setMaxNum', hua.maxNum);
                        // that.$store.dispatch('setAreadyNum', hua.areadyNum);
                      }
                    }
                  }
              })
          },
          //初始化产品列表配置数据
          getStyle() {
            var that = this;
              doJsonPost('/main/getStyle', null, rs => {
                console.info("getStyle====")
                  console.info(rs)
                  if (rs.result === 'success') {
                     that.$store.dispatch('setShopName', rs.userData.name);
					if(rs.userData.logo){
					  that.$store.dispatch('setLogo', rs.userData.logo);
					}
                    if(rs.userData.shopStyle){
                      that.$store.dispatch('setStyleTheme', rs.userData.shopStyle);
                    }else{
                      that.$store.dispatch('setStyleTheme', 'style-1');
                    }

                  }else{
                     that.$store.dispatch('setStyleTheme', 'style-1');
                  }
              })
          },
          getIfEnterpriseGoods(){
            doJsonPost('/wechatLogin/getIfEnterpriseGoods', null, rs => {
              if (rs.result === 'success') {
                setIfEnterprise(rs.userData.isEnterprise);
                this.$store.dispatch('setIfEnterpriseGoods', rs.userData.isEnterprise);
                if(rs.userData.enterpriseCode!=null){
                  this.$store.dispatch('setEnterpriseCode', rs.userData.enterpriseCode);
                }
                this.$store.dispatch('setIndustryCode', rs.userData.industryCode);
                this.vipState=rs.userData.vipState=='1';
                this.$store.dispatch('setVipState', this.vipState);
              }
            })
          },
            initGlobalData() {
                doJsonPost('/main/getShopConfig.do', null, res => {
                    if (res.result == 'success') {
                      if(res.userData&& res.userData.shopTheme){
                        this.$store.dispatch('setThemeColors', res.userData.shopTheme.themeColor);
                      }
                        var resFormat = res.userData.shopFormats;
                        var themeFormat = {
                            name: resFormat.name,
                            // name: resFormat.name,
                            tabbarIcons: {
                                home: '../static/imgs/home2.png',
                                homeOn: '../static/imgs/home1.png',
                                category: resFormat.category,
                                categoryOn: resFormat.categoryOn,
                                cart: '../static/imgs/gouwuche.png',
                                cartOn: '../static/imgs/gouwuche1.png',
                                user: resFormat.user,
                                userOn: resFormat.userOn,
                                wodeOn: '../static/imgs/wode.png',
                                wode: '../static/imgs/wode2.png',

                            }
                        }
                        this.$store.dispatch('setThemeFormat', themeFormat);
                        // 动态更改页面标题
                        if (res.userData.mainPage.title) {
                            document.title = res.userData.mainPage.title
                        }
                    }
                })
            },
            getCustomerService() {
                doJsonPost('/main/queryCustomerService', null, rs => {
                    if (rs.result === 'success') {
                        setCustomerService(rs.userData);
                    }
                })
            },

          onChange(index){
            let page = 'click_home_tab';
            let pageTag = '首页';
            if(index==1){
              page='click_category_tab';
              pageTag = '商城';
            }
            if(index==2){
              page='click_88vip_tab';
              pageTag = '定制顾问';
            }
            if(index==3){
              page='click_add_shopping_cart_tab';
              pageTag = '购物车';
            }
            if(index==4){
              page='click_my_tab';
              pageTag = '我的';
            }
            this.sendRecord(page,{pageTag: pageTag})
          },
          getUserInfo(){
            doJsonPost('/userInfo/getUserInfo', null, rs => {
              if (rs.result == 'success') {
                var rsData = rs.userData;
                this.tenantType=rsData.tenantType
                setTenantType(this.tenantType)
                const myNick = rsData.myNick
                const myCode = rsData.myCode
                const {aplus_queue} = window;
                //如采集用户信息是异步行为，需要先阻止SDK上报，设置BLOCK埋点
                aplus_queue.push({
                  action: 'aplus.setMetaInfo',
                  arguments: ['_hold', 'BLOCK']
                });

                //异步耗时流程 (如获取user_id)
                aplus_queue.push({
                  action: 'aplus.setMetaInfo',
                  arguments: ['_user_id',myCode]
                });

                aplus_queue.push({
                  action: 'aplus.setMetaInfo',
                  arguments: ['_user_nick',myNick]
                });

            // 因为采集用户信息是异步行为，故需要先设置BLOCK，再设置START
            // 设置_hold=START后，事先被block住的日志会携带上用户信息逐条发出
                aplus_queue.push({
                  action: 'aplus.setMetaInfo',
                  arguments: ['_hold', 'START']
                });
              } else {
                Toast(rs.message);
              }
            });
          }
        },
    }
</script>

<style  scoped>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
/* iphoneX XS XR等底部适配问题 */
@supports (bottom: env(safe-area-inset-bottom)) {
  body,
  .footer >>> .van-tabbar{
    padding-bottom: 10px;
    padding-bottom: calc(10px + constant(safe-area-inset-top));
    padding-bottom: calc(10px + env(safe-area-inset-top));
  }
}
.footer >>> .van-tabbar-item__text{
  /* margin-bottom: 4px; */
  color:#909399;
  font-weight: 400;
  font-size: 11px;
}
.footer >>> .van-tabbar-item--active i{
  color:#333;
}
.footer >>> .van-tabbar-item--active .van-tabbar-item__text{
  color:#333;
}
.footer >>> .van-tabbar-item__icon{
  text-align: center;
}
.service{
    position: absolute;
    left: 50%;
    right: 0;
    top: -24px;
    z-index: 99;
    background: #ffffff;
    border-radius: 50%;
    padding: 8px;
    display: block;
    width:40px;
    height: 32px;
    margin: 0 auto;
    transform: translate(-50%, 0);
    font-size: 26px;
}
.servicetxt{
  margin-top: 20px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/App.vue